import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { sourcingFormExtended, futureProjectForm } from 'dibs-trade-onboarding';
import scrollIntoView from 'scroll-into-view';
import get from 'lodash.get';
import tracking from 'dibs-tracking';

import Header from './Header';
import { ContentHead, ContentBody } from './Content';
import Contact from './Contact';
import LoggedOut from './LoggedOut';
import Link from './Link';

const onSubmit = () => {
    const element = document.querySelector('.js-sourcing-form');
    if (element) {
        scrollIntoView(element, { time: 1000 });
    }
};

export class TradeSourcingWrapperComponent extends React.Component {
    componentDidMount() {
        tracking.trackPageview({
            additional: {
                pageType: 'Other',
                pageSubType: 'Other',
            },
        });
    }

    render() {
        const { showChatUtils, viewer } = this.props;
        const isLoggedIn = !!get(viewer, 'user');
        const isTrade = !!get(viewer, 'user.isVerifiedTrade');

        let formElement = null;

        if (isTrade) {
            const isProjectSourcingPage = window.location.pathname.includes('project-sourcing');
            const formComponent = isProjectSourcingPage ? futureProjectForm : sourcingFormExtended;
            const { SourcingForm } = formComponent({
                buyerEmail: get(viewer, 'user.profile.email'),
                onSubmit,
            });
            formElement = <SourcingForm />;
        } else if (isLoggedIn) {
            formElement = <Link />;
        } else {
            formElement = <LoggedOut />;
        }

        return (
            <div className="wrapper">
                <Header />
                <ContentHead />
                <div id="sourcingForm" className="js-sourcing-form form rowFlex">
                    <div className="rowWrapper">{formElement}</div>
                </div>
                <ContentBody />
                <Contact showChatUtils={showChatUtils} />
            </div>
        );
    }
}

TradeSourcingWrapperComponent.propTypes = {
    relay: PropTypes.object,
    userId: PropTypes.string,
    viewer: PropTypes.object,
    showChatUtils: PropTypes.func,
};

export const TradeSourcingWrapper = createFragmentContainer(TradeSourcingWrapperComponent, {
    viewer: graphql`
        fragment TradeSourcingWrapper_viewer on Viewer {
            user(userId: $userId) @include(if: $hasUserId) {
                isVerifiedTrade: hasPermission(name: "B_NET_PRICE")
                profile {
                    email
                }
            }
        }
    `,
});
